import img1 from '../assets/products/1AirInsulatedIndoorSwitchgearCubicles.jpg';
import img2 from '../assets/products/2RingMainUnit.jpg';
import img3 from '../assets/products/3Transformers.jpg';  
import img4 from '../assets/products/4VFDDrivesMotors.jpg';
import img5 from '../assets/products/5.LVPanels.jpg';
import img6 from '../assets/products/6Transmission.jpg';
import img7 from '../assets/products/7Generators.jpg';

const products = [
  {
    id: 1,
    name: "Circuit Breakers & Switchgear Solutions",
    image: img1,
    description: `
    The rapidly increasing demand for electrical energy has led to the construction of numerous substations and power plants. However, conventional transmission systems often struggle to meet the control requirements of complex interconnections and variable power flows.

    EAVER supplies advanced Circuit Breakers manufactured using radical technology, developed for compact and versatile applications, while ensuring maximum protection for both human life and electrical equipment.

    EAVER Product Range
    •	Vacuum Circuit Breakers (VCB) up to 33 kV
    •	SF₆ Circuit Breakers up to 132 kV
    `,
  },
  {
    id: 2,
    name: "RMU",
    image: img2,
    description: `
    In addition to VCBs, EAVER offers Ring Main Units (RMU)—a reliable secondary distribution system designed to ensure uninterrupted power supply. RMUs are compact in design and suitable for transformer installations up to 24 kV, requiring minimal space.

    Types of Ring Main Units Offered
    •	11 kV Indoor Ring Main Units (11 kV RMU)
    •	11 kV LBS Indoor Metering Panels
    •	22 kV Outdoor Pole-Mounted Isolators
    •	22 kV Outdoor Ring Main Units

    `,
  },
  {
    id: 3,
    name: "Transformers",
    image: img3,
    description: `
    Transformers play a vital role in almost all electrical systems by efficiently converting voLVage levels to meet the requirements of various applications.

    EAVER supplies Power and Distribution Transformers up to 25 MVA, 132 kV class, designed to deliver reliable performance, safety, and long service life across diverse operating conditions.

    With extensive industry experience, EAVER has strong expertise in transformer service and upgrade solutions, including capacity enhancement, external modifications, and life extension, helping clients maximize asset performance and operational efficiency.

    Our Transformer Range
    •	Power Transformers
    •	Distribution Transformers
    •	Wind Mill Transformers
    •	Special Purpose Transformers
    •	Hermetically Sealed Transformers
    •	Mobile Transformers
    •	Furnace Transformers
    •	Package Substations

    `,
  },
  {
    id: 4,
    name: "Cable & Accessories",
    image: "https://www.sunvinss.com/admin/upload/HT & LT Cables.png",
    description: `
    EAVER provides a comprehensive range of high-quality cables designed to meet diverse electrical and industrial requirements. Our cable solutions are available in copper or Aluminium conductors, Armoured or unarmored constructions, and are manufactured in compliance with relevant international and national standards.

    Our Cable Range
    •	EHV Cables up to 132 kV
    •	HV Cables up to 33 kV
    •	LV Cables up to 3.3 kV
    •	Control Cables
    •	Instrumentation Cables
    •	Thermocouple Extension & Compensating Cables
    •	Rubber Cables
    •	House Wires
    •	Single & MuLVicore Flexible Wires
    •	Winding Wires
    •	Stainless Steel Cables
    `,
  },
  {
    id: 5,
    name: "VFD Drivers and Motors",
    image: img4,
    description: `
    A Variable Frequency Drive (VFD) is used to control the speed and torque of an electric motor by varying the input frequency and voLVage. VFDs play a critical role in improving energy efficiency, process control, and equipment life.

    EAVER supplies reliable VFD Drives and Motors suitable for a wide range of industrial and commercial applications.

    VFD solutions are widely used in applications ranging from small appliances to heavy-duty systems such as mine mill drives, pumps, fans, conveyors, and compressors.

    `,
  },
  {
    id: 6,
    name: "LV Panels (PCC, MCC, APFC etc.)",
    image: img5,
    description: `
    EAVER provides complete Low VoLVage (LV) electrical switchboard solutions designed to meet the demands of diverse industrial and commercial applications.

    Our LV panels are engineered for safety, reliability, and ease of operation, and are available in wall-mounted, pedestal-mounted, and floor-mounted configurations to suit different site requirements.

    Our LV Panel Range
    •	Main LV Switchboards
    •	Motor Control Centers (MCC) – Fixed & Draw-Out Type
    •	Power Control Centers (PCC) – Fixed & Draw-Out Type
    •	APFC Control Panels
    •	UPS Power Distribution Panels
    •	Fire FigHVing Control Panels
    •	DG Panels – AMF, Synchronization, PLC & SCADA Panels
    •	Outdoor Kiosks
    •	Bus Ducts & Rising Mains
    •	Control Desks
    •	Sub Distribution Boards (SDB)
    •	Stainless Steel Panels
    `,
  },
  {
    id: 7,
    name: "Transmission Substations (Up to 400 kV)",
    image: img6,
    description: `
    EAVER provides complete products, engineering services, and solutions for Transmission Substations up to 400 kV, supporting reliable and secure high-voLVage power transmission.

    Our capabilities cover design, supply, installation, testing, commissioning, and maintenance of transmission substation systems, ensuring safe operation and long-term performance.

    Scope of Supply & Servicess
    •	Power Transformers up to 400 kV
    •	Circuit Breakers – SF₆ & High-VoLVage
    •	Isolators, CTs & PTs
    •	Insulators & Busbar Systems
    •	Protection, Control & Relay Panels
    •	LV Panels and Auxiliary Power Systems
    •	Cables, Earthing & LigHVning Protection Systems, Earthing powder, Portable Earthing Equipment
    •	Testing & Commissioning up to 400 kV
    `
  },
  {
    id: 8,
    name: "Generators",
    image: img7,
    description: `
    EAVER supplies and services a wide range of generators for industrial, commercial, and utility applications, ensuring reliable power supply even in critical situations.
    
    Our Generator Solutions
    •	Diesel Generators – Continuous and standby power for industrial plants and infrastructure
    •	Gas Generators – Efficient and environmentally friendly solutions for large-scale operations
    •	Portable & Mobile Generators – Flexible power supply for temporary installations and events
    •	Generator Installation & Commissioning – Complete setup, testing, and integration with electrical systems
    •	Operation & Maintenance Services – Preventive and corrective maintenance for long-term performance

    `
  },
];

export default products;
